import { render, staticRenderFns } from "./UpdateSalaryContent.vue?vue&type=template&id=032dc523"
import script from "./UpdateSalaryContent.vue?vue&type=script&lang=js"
export * from "./UpdateSalaryContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports